import smoothScroll from './smoothScroll'

export default ( selector, ...params ) => {
	const elem = document.querySelector(selector);
	if (!elem) throw new Error(`element ${selector} doesnt exist!`);
	return smoothScroll(elem.getBoundingClientRect().top, ...params);
}
